import React from 'react';
import { Stack } from '@mui/material';
import { ToDoPanel, DoingPanel, DonePanel } from '../components';
import { Task, SequenceFlow } from '../model/activitiesModel';

interface MyActivitiesPanelsProps {
  loading: boolean;
  completeLabel: boolean;
  setDetail: (id: number | null) => void;
  fromTodoTo_Doing: (task: Task) => Promise<void>;
  dragItem: Task | null;
  userId: number;
  switchChecked: boolean;
  administrator: boolean;
  processedToDoTasks: Task[];
  showOnlyIdUserZero: boolean;
  setShowOnlyIdUserZero: (value: boolean | ((prev: boolean) => boolean)) => void;
  view: 'minimal' | 'compact' | 'extended';
  fromDoingTo_Done: (task: Task) => Promise<void>;
  fromDoingTo_Todo: (task: Task) => Promise<void>;
  fromDoingTo_Sequence: (task: Task, sequenceFlow: SequenceFlow) => Promise<void>;
  processedDoingTasks: Task[];
  all: boolean;
}

const MyActivitiesPanels: React.FC<MyActivitiesPanelsProps> = ({
  loading,
  completeLabel,
  setDetail,
  fromTodoTo_Doing,
  dragItem,
  userId,
  switchChecked,
  administrator,
  processedToDoTasks,
  showOnlyIdUserZero,
  setShowOnlyIdUserZero,
  view,
  fromDoingTo_Done,
  fromDoingTo_Todo,
  fromDoingTo_Sequence,
  processedDoingTasks,
  all,
}) => {
  return (
    <Stack
      sx={{ overflow: "hidden" }}
      direction="row"
      overflow="auto"
      height="100%"
      spacing={2}
      width={'fit-content'}
    >
      <Stack
        sx={{
          overflow: "hidden",
          minWidth: 340,
          width: 340,
          pb: 2,
        }}
        height="100%"
      >
        <ToDoPanel
          loading={loading}
          labelCompleteMode={completeLabel}
          setDetail={setDetail}
          goToDoing={fromTodoTo_Doing}
          dragItem={dragItem}
          all={all}
          userId={userId}
          switchChecked={switchChecked}
          administrator={administrator}
          processedTasks={processedToDoTasks}
          showOnlyIdUserZero={showOnlyIdUserZero}
          setShowOnlyIdUserZero={setShowOnlyIdUserZero}
          view={view}
        />
      </Stack>
      <Stack
        sx={{
          overflow: "hidden",
          minWidth: 340,
          width: 340,
          pb: 2,
        }}
        height="100%"
      >
        <DoingPanel
          loading={loading}
          labelCompleteMode={completeLabel}
          setDetail={setDetail}
          goToDone={fromDoingTo_Done}
          goTodo={fromDoingTo_Todo}
          handleSequenceFlowChoice={fromDoingTo_Sequence}
          dragItem={dragItem}
          all={all}
          userId={userId}
          switchChecked={switchChecked}
          administrator={administrator}
          processedTasks={processedDoingTasks}
          view={view}
          showOnlyIdUserZero={showOnlyIdUserZero}
        />
      </Stack>
      <Stack
        sx={{
          overflow: "hidden",
          minWidth: 340,
          width: 340,
        }}
        height="100%"
      >
        <DonePanel dragItem={dragItem} />
      </Stack>
    </Stack>
  );
};

export default MyActivitiesPanels;
